module.exports = __webpack_public_path__ + "img/lab-topology.4862e32d.png";